export const messages = {
  taxNotification:
    'As of October 1, 2024 Alberta requires a 4% tourism tax levy on accommodations. This will be calculated and displayed on the booking summary page.'
};
